module.exports = __webpack_public_path__ + "odinstatic/v17.0.0/media/pricing.9d77b4b6.svg";